import { polishPlurals } from 'polish-plurals';

export default function pointsWithText(points: number) {
    const text = polishPlurals('keton', 'ketony', 'ketonów', points);
    return `${points} ${text}`;
}
